import request from '@/utils/request'
import requestFee from '@/utils/request-no-toast'

export function captcha(param) {
  return request({
    url: '/admin/v1/captcha',
    method: 'get',
    params: param
  })
}

export function authSms(data) {
  return request({
    url: '/admin/v1/auth/sms',
    method: 'post',
    data
  })
}

export function login(data) {
  return request({
    url: '/admin/v1/auth/login',
    method: 'post',
    data
  })
}

export function Initpassword(data) {
  return request({
    url: '/admin/v1/auth/activation',
    method: 'post',
    data
  })
}

export function getInfo(token) {
  return request({
    url: '/admin/v1/auth/layout',
    method: 'get',
    params: { token }
  })
}

export function logout() {
  return request({
    url: '/admin/v1/auth/logout',
    method: 'post'
  })
}
// 查询用户状态
export function userStatus() {
  return request({
    url: '/admin/v1/status/user',
    method: 'get'
  })
}
// 重置密码身份验证
export function authCheck(data) {
  return request({
    url: '/admin/v1/auth/getToken',
    method: 'post',
    data: data
  })
}
// 重置密码
export function resetPassword(data) {
  return request({
    url: '/admin/v1/auth/changePassWord',
    method: 'post',
    data
  })
}
// --重置密码
export function resetfeePassword(data) {
  return requestFee({
    url: '/admin/v1/auth/changePassWord',
    method: 'post',
    data
  })
}

// 用户行为收集日志
export function userEventRemoteCollect(data) {
  return requestFee({
    url: '/admin/v1/behavior/collect',
    method: 'POST',
    data
  })
}

// 用户异地登录日志列表
export function getUserEventRemoteCollectList(params) {
  return requestFee({
    url: '/admin/v1/behavior/collect/list',
    method: 'GET',
    params
  })
}

// 获取异地登录用户行为日志列表
export function getUserEventRemoteCollectLogList(params) {
  return requestFee({
    url: '/admin/v1/behavior/collect/log/list',
    method: 'GET',
    params
  })
}

// 是否展示手机验证码模块
export function getAuthRender(data) {
  return requestFee({
    url: '/admin/v1/auth/render',
    method: 'POST',
    data
  })
}